// Auth Header
import authHeader from "./auth-header";
// Base Url
import { BASE_URL, NODE_BASE_URL } from "../config/siteUrls";
import superagent from "superagent";
import instance from "./api";
import axios from "axios";
class UserService {
  getAllSchoolType() {
    return instance.get("api/school/getAllSchoolTypes", {
      headers: authHeader(),
    });
  }
  getSpecialtyDropdown() {
    return instance.get("api/admin/getAllSpecialtyDropdown", {
      headers: authHeader(),
    });
  }
  getAllAthletes(id) {
    return instance.get("api/athlete/get-all-athelets-by-coach/" + id, {
      headers: authHeader(),
    });
  }
  getAllStates() {
    return instance.post("api/school/getAllStates", {
      headers: authHeader(),
    });
  }
  getAllStateList(countryId) {
    return instance.post(`api/school/getAllStates/${countryId}`, {
      headers: authHeader(),
    });
  }
  getAllSchool() {
    return instance.get("api/school/getAllSchoolsDropdown", {
      headers: authHeader(),
    });
  }
  getAllCoaches(schoolId) {
    return instance.get("api/coach/get-all-coaches-by-school/" + schoolId, {
      headers: authHeader(),
    });
  }

  getAllTeams(id) {
    return instance.get("api/team/get-all-teams-by-school/" + id, {
      headers: authHeader(),
    });
  }
  getSchoolDetails(id) {
    return instance.get("api/school/getSchoolById/" + id, {
      headers: authHeader(),
    });
  }

  getGroupDetails(id) {
    return instance.get("api/group/getGroupById/" + id, {
      headers: authHeader(),
    });
  }

  getCoachDetails(id) {
    return instance.get("api/admin/getCoachById/" + id, {
      headers: authHeader(),
    });
  }
  getAthleteDetails(id) {
    return instance.get("api/admin/getAthleteById/" + id, {
      headers: authHeader(),
    });
  }

  getAllHighlightsForSchool(schoolId) {
    return instance.get("api/highlight/getAllHighlighteds/" + schoolId, {
      headers: authHeader(),
    });
  }

  //create highlight request approval part
  getAllHighlightsRequest(page, size) {
    return instance.get(
      `api/highlight/getAllHighlighteds?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  approveHighlightRequest(id, isApproved) {
    return instance.post(
      "api/highlight/approveHighlightRequest",
      { id, isApproved },
      {
        headers: authHeader(),
      }
    );
  }

  deleteHighlight(id) {
    return instance.post(`api/highlight/deleteHighlight${id}`, {
      headers: authHeader(),
    });
  }

  getAllAthlete() {
    return instance.get("api/admin/getAllAthlete", {
      headers: authHeader(),
    });
  }

  getAllSports(schoolId) {
    return instance.get(`api/school/getAllSports`, {
      headers: authHeader(),
    });
  }

  getAllSchoolListing() {
    return instance.get("api/school/getAllSchoolsDropdown", {
      headers: authHeader(),
    });
  }

  getSchoolBillingDetails(schoolId) {
    return instance.get("api/payments/getBillingBySchool/" + schoolId, {
      headers: authHeader(),
    });
  }

  getSchoolBillingDetailsByPage(schoolId, page, size) {
    return instance.get(
      `api/payments/getBillingBySchool/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getAllBillingListing() {
    return instance.get("api/payments/getAllBilling", {
      headers: authHeader(),
    });
  }

  getAllEventLibrary(categoryNameList, schoolId, searchBy, filterDates) {
    return instance.post(
      "api/event/searchEvents",
      { categoryNameList, schoolId, searchBy, filterDates },
      {
        headers: authHeader(),
      }
    );
  }
  getEventMedia(playListID, page, size) {
    return instance.get(
      `api/event/eventMedia/byPlaylist/${playListID}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }
  getPaginationEvents(body, eventPage) {
    return instance.post(
      `/api/event/getEventPlaylist?size=3&page=${eventPage}`,
      { ...body },
      {
        headers: authHeader(),
      }
    );
  }

  getAllEventLibraryByPage(schoolId, page, size) {
    return instance.get(
      "api/event/getAllEvents/" + schoolId + "?page=" + page + "&size=" + size,
      {
        headers: authHeader(),
      }
    );
  }

  getAllActivityByPage(page, size) {
    return instance.get(
      "api/event/getAllActivity" + "?page=" + page + "&size=" + size,
      {
        headers: authHeader(),
      }
    );
  }

  getAllCountries() {
    return instance.get("api/school/loadAllCountries", {
      headers: authHeader(),
    });
  }

  getAllStateOfCountry(id) {
    return instance.post(`${BASE_URL}api/school/getAllStates/${id}`, {
      headers: authHeader(),
    });
  }

  getSchoolDetailsViaToken(token) {
    return instance.get("api/school/getSchoolFromVerifyLink/" + token, {
      headers: authHeader(),
    });
  }

  getDefaultBreakdown(currentUserId, page, size, defaultColumnSetName) {
    return instance.get(
      `api/event/defaultBreakdown?userId=${currentUserId}&columnSetName=${defaultColumnSetName}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getSchoolAdminDashboardData(schoolId) {
    return instance.get("api/dashboard/getSchoolFeed/" + schoolId, {
      headers: authHeader(),
    });
  }

  getBreakdownDataAfter() {
    return instance.get("api/event/getAllActiveBreakdown", {
      headers: authHeader(),
    });
  }

  getSuperAdminDashboard() {
    return instance.get("api/dashboard/getActiveInActiveSchoolCount", {
      headers: authHeader(),
    });
  }

  getSchoolAdminDashboardGraph() {
    return instance.get("api/dashboard/getCoachOnboardGraphData", {
      headers: authHeader(),
    });
  }

  getSchoolAdminDashboardGraphAthelete() {
    return instance.get("api/dashboard/getAthleteOnboardGraphData/", {
      headers: authHeader(),
    });
  }

  getNumberApi() {
    return instance.get("api/event/setActiveBreakdownNumbering", {
      headers: authHeader(),
    });
  }

  getBreakdownColumnListingData(categoryId, playlistId, eventId) {
    return instance.post(
      "api/event/getAllMediaBreakdownColumn",
      { categoryId, playlistId, eventId },
      {
        headers: authHeader(),
      }
    );
  }

  changeSequenceActiveColumns(breakdownId, status, positionNumber) {
    return instance.post(
      "api/event/breakdownUpAndDownByNumber",
      { breakdownId, status, positionNumber },
      {
        headers: authHeader(),
      }
    );
  }

  addFAQPost(question, answer) {
    return instance.post(
      "api/website/addFAQs",
      { question, answer },
      {
        headers: authHeader(),
      }
    );
  }

  copyLinkGet(emails, schoolId) {
    return instance.post(
      "api/school/invite-athelete-for-copy-link",
      { emails, schoolId },
      {
        headers: authHeader(),
      }
    );
  }

  sendLinkAtheletePost(emails, schoolId) {
    return instance.post(
      "api/school/invite-athelete",
      { emails, schoolId },
      {
        headers: authHeader(),
      }
    );
  }

  addRelatedProductPost(title, details, filesId) {
    return instance.post(
      "api/website/addProductRelatedVideos",
      { title, details, filesId },
      {
        headers: authHeader(),
      }
    );
  }

  getFaqQuestions() {
    return instance.get("api/website/getAllFAQs");
  }

  viewCountPost(isViews, shareMediaId) {
    return instance.post(
      "api/share/addViewsCount",
      { isViews, shareMediaId },
      {
        headers: authHeader(),
      }
    );
  }

  getRelatedVideo() {
    return instance.get("api/website/getAllProductRelatedVideos", {
      // headers: authHeader(),
    });
  }

  hiddenColumnSerch(searchString) {
    return instance.get("api/event/searchHiddenBreakdown/" + searchString, {
      headers: authHeader(),
    });
  }

  videoLibrarySearch(searchString) {
    return instance.get("api/event/searchEvent/" + searchString, {
      headers: authHeader(),
    });
  }

  adminSchoolData(schoolId) {
    return instance.get("api/dashboard/getSchoolAdminUsersCount/" + schoolId, {
      headers: authHeader(),
    });
  }

  activeColumnSerch(searchString) {
    return instance.get("api/event/searchActiveBreakdown/" + searchString, {
      headers: authHeader(),
    });
  }

  addSchoolAdminRegistration() {
    return instance.post("api/admin/addSchoolAdmin", {
      headers: authHeader(),
    });
  }

  getHighlightsForSchool() {
    return instance.get("api/share/getHighLightedWebsite");
  }

  getTrendingDetails(schoolId) {
    return instance.get("api/share/getFeedByTrending/" + schoolId, {
      headers: authHeader(),
    });
  }

  getVideoFeedShow(schoolId, page) {
    return instance.get(
      `api/event/getFeedByShareMedia/${schoolId}?page=${page}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchHighlightsVideo(searchString) {
    return instance.get("api/website/searchHighlightedVideos/" + searchString);
  }

  getVideoFeedShowCoach(schoolId) {
    return instance.get(
      "api/dashboard/getCoachAthleteTeamAdminByShareMedia/" + schoolId,
      {
        headers: authHeader(),
      }
    );
  }

  getHighlighteSchoolRequest() {
    return instance.get("api/share/getHighLightedVideo", {
      headers: authHeader(),
    });
  }

  getHighlightsDataByPage(page, size) {
    return instance.get(
      `api/share/getHighLightedVideo?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchHighlight(query, page, size) {
    return instance.get(
      `api/highlight/getAllHighlighteds?searchString=${query}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  statesListBycountryId() {
    return instance.post("api/school/getAllStates/", {
      headers: authHeader(),
    });
  }
  deleteSchool() {
    return instance.delete("api/school/deleteSchool", {
      headers: authHeader(),
    });
  }
  checkEmailInUser(email) {
    return instance.get("api/auth/checkEmailInUse?email=" + email, {
      headers: authHeader(),
    });
  }

  checkEmailsInUser(emails) {
    return instance.post("api/auth/checkEmailsInUse", emails, {
      headers: authHeader(),
    });
  }

  readNotificationPost(notificationId) {
    return instance.get("api/notify/read-notifications/" + notificationId, {
      headers: authHeader(),
    });
  }

  readAllNotificationPost(ids) {
    return instance.post("api/notify/markAllAsReadNotifications", ids, {
      headers: authHeader(),
    });
  }

  deleteNotificationPost(notificationId) {
    return instance.get("api/notify/delete-notifications/" + notificationId, {
      headers: authHeader(),
    });
  }

  postLogoForAll(data) {
    return instance.post("api/file/uploadLogo", data, {
      headers: authHeader(),
    });
  }
  postLogoForSuperAdmin(data) {
    return instance.post("api/file/superAdmin/uploadLogo", data, {
      headers: authHeader(),
    });
  }

  postLogoForSuperAdmin(data) {
    return instance.post("api/file/superAdmin/uploadLogo", data, {
      headers: authHeader(),
    });
  }

  postLogoWithoutLogin(data) {
    return instance.post("api/file/uploadLogoPermitAll", data, {
      headers: authHeader(),
    });
  }

  setOwnPassword(token, password, confirmPassword) {
    return instance.post(
      "api/auth/password/setPassword",
      { token, password, confirmPassword },
      { headers: authHeader() }
    );
  }

  getSchoolGraphDetails(year) {
    return instance.get("api/dashboard/getSchoolOnboardGraphData/" + year, {
      headers: authHeader(),
    });
  }

  getSchoolActivity() {
    return instance.get("api/event/getAllActivity", {
      headers: authHeader(),
    });
  }

  getNotificationData() {
    return instance.get("api/notify/get-notifications", {
      headers: authHeader(),
    });
  }

  getNotificationDataByPage(page, size) {
    return instance.get(
      "api/notify/get-notifications" + "?page=" + page + "&size=" + size,
      { headers: authHeader() }
    );
  }

  setResetPassword(token, password, confirmPassword) {
    return instance.post(
      "api/auth/password/reset",
      { token, password, confirmPassword },
      { headers: authHeader() }
    );
  }

  postContactUs(email, message, name, phoneNo, subject) {
    return instance.post(
      "api/website/addContactUs",
      { email, message, name, phoneNo, subject },
      { headers: authHeader() }
    );
  }

  sendApproveRequest(shareMediaId, isHighlighted, highlightId) {
    return instance.post(
      "api/share/updateHilightedVideo",
      { shareMediaId, isHighlighted, highlightId },
      { headers: authHeader() }
    );
  }

  billAddPost(
    amount,
    note,
    paymentMethod,
    paymentStatus,
    schoolId,
    uploadFilesInvoiceId,
    validityDate
  ) {
    return instance.post(
      "api/payments/addBilling",
      {
        amount,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate,
      },
      { headers: authHeader() }
    );
  }

  filterVideoLirary(categoryNameList, schoolId) {
    return instance.post(
      "api/event/eventFilterByCategory",
      { categoryNameList, schoolId },
      { headers: authHeader() }
    );
  }

  getHeaderData() {
    return instance.get("api/website/getHeaderMenu", {
      headers: authHeader(),
    });
  }

  getFooterData() {
    return instance.get("api/website/getFooter");
  }

  addHeaderMenus(blog, contactUs, guidelines, highlights, home, pricing) {
    return instance.post(
      "api/website/addHeaderMenu",
      { blog, contactUs, guidelines, highlights, home, pricing },
      { headers: authHeader() }
    );
  }

  updateHeaderMenus(
    blog,
    contactUs,
    guidelines,
    highlights,
    home,
    pricing,
    id
  ) {
    return instance.post(
      "api/website/updateHeaderMenu",
      { blog, contactUs, guidelines, highlights, home, pricing, id },
      { headers: authHeader() }
    );
  }

  addFooterMenus(
    details,
    facebookLink,
    instagramLink,
    linkedinLink,
    twitterLink,
    youtubeLink
  ) {
    return instance.post(
      "api/website/addFooter",
      {
        details,
        facebookLink,
        instagramLink,
        linkedinLink,
        twitterLink,
        youtubeLink,
      },
      { headers: authHeader() }
    );
  }

  updateFooterMenus(
    details,
    facebookLink,
    instagramLink,
    linkedinLink,
    twitterLink,
    youtubeLink,
    id
  ) {
    return instance.post(
      "api/website/updateFooter",
      {
        details,
        facebookLink,
        instagramLink,
        linkedinLink,
        twitterLink,
        youtubeLink,
        id,
      },
      { headers: authHeader() }
    );
  }

  postFeedMerge(
    eventId,
    eventMediaId,
    shareOnId,
    videoDescription,
    videoTitle,
    schoolId,
    athletes,
    coaches,
    teamAdmins
  ) {
    return instance.post(
      "api/event/saveShareVideo",
      {
        eventId,
        eventMediaId,
        shareOnId,
        videoDescription,
        videoTitle,
        schoolId,
        athletes,
        coaches,
        teamAdmins,
      },
      { headers: authHeader() }
    );
  }

  postFeedMergeHighlight({
    eventId,
    eventMediaId,
    shareOnId,
    videoDescription,
    videoTitle,
    schoolId,
    athletes,
    coaches,
    highlightId,
  }) {
    return instance.post(
      "api/event/saveShareVideoHighlight",
      {
        eventId,
        eventMediaId,
        shareOnId,
        videoDescription,
        videoTitle,
        schoolId,
        athletes,
        coaches,
        highlightId,
      },
      { headers: authHeader() }
    );
  }

  getEditedPlaylistData(categoryId, evenId, isEdited, playlistId, schoolId) {
    return instance.post(
      "api/event/getEditedMedia",
      { categoryId, evenId, isEdited, playlistId, schoolId },
      { headers: authHeader() }
    );
  }

  getCoachSchoolDetails(coachId) {
    return instance.post(
      "api/event/getCoachSchools",
      { coachId },
      { headers: authHeader() }
    );
  }

  addBreakDownColumn(
    breakdownName,
    breakdownTypeId,
    possibleValues,
    schoolId,
    columnNameId
  ) {
    return instance.post(
      "api/event/addBreakdown",
      {
        breakdownName,
        breakdownTypeId,
        possibleValues,
        schoolId,
        columnNameId,
      },
      { headers: authHeader() }
    );
  }

  activeToHiddenCall(breakdownIds, isActive, categoryId, playlistId, eventId) {
    return instance.post(
      "api/event/markBreakdownToActive",
      { breakdownIds, isActive, categoryId, playlistId, eventId },
      { headers: authHeader() }
    );
  }

  InactiveToHiddenCall(
    breakdownIds,
    isActive,
    categoryId,
    playlistId,
    eventId
  ) {
    return instance.post(
      "api/event/markBreakdownToInactive",
      { breakdownIds, isActive, categoryId, playlistId, eventId },
      { headers: authHeader() }
    );
  }

  MergeVideoUrlSend(
    categoryId,
    evenId,
    playlistId,
    mergeVideoUrl,
    editedVideoName,
    schoolId
  ) {
    return instance.post(
      "api/event/saveEditedMedia",
      {
        categoryId,
        evenId,
        playlistId,
        mergeVideoUrl,
        editedVideoName,
        schoolId,
      },
      { headers: authHeader() }
    );
  }
  sendLiveStreamingNotification({ id, schoolId, associationType }) {
    return instance.post(
      "api/channel/sendNotificationForStream",
      {
        id,
        schoolId,
        associationType,
      },
      { headers: authHeader() }
    );
  }
  saveFinalHighlight(
    videoName,
    videoUrl,
    schoolId,
    eventMediaId,
    eventId,
    shareOnId
  ) {
    return instance.post(
      "api/highlight/createHighlights",
      {
        videoName,
        videoUrl,
        schoolId,
        eventMediaId,
        eventId,
        shareOnId,
        shareMediaId: null,
      },
      { headers: authHeader() }
    );
  }

  saveEditFinalHighlight(
    eventMediaId,
    highlightedId,
    schoolId,
    videoName,
    videoUrl
  ) {
    return instance.post(
      "api/highlight/editHighlights",
      { eventMediaId, highlightedId, schoolId, videoName, videoUrl },
      { headers: authHeader() }
    );
  }

  sendIntercutValues(request) {
    return instance.post(
      "api/event/intercutUpAndDownByNumber",
      { request },
      { headers: authHeader() }
    );
  }

  localKinesisStreamSave(kinesisUrl, startTime, duration) {
    return instance.post(
      "https://devapi.contendzone.com/node/clipping/videoClipping",
      { kinesisUrl, startTime, duration }
      // { headers: authHeader() }
    );
  }

  sendColumnValues(mediaBreakdownId, value) {
    return instance.post(
      "api/event/updateMediaBreakdownById",
      { mediaBreakdownId, value },
      { headers: authHeader() }
    );
  }

  mergeVideoApi(videoPath) {
    return instance.post(
      "https://devapi.contendzone.com/node/video/mergeVideo",
      { videoPath },
      {
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          // "Content-Security-Policy": "upgrade-insecure-requests"
        },
      }
    );
  }

  annotateVideoApi(videoPath) {
    return instance.post(
      "https://devapi.contendzone.com/node/video/mergeAnnotationVideo",
      { videoPath },
      {
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          // "Content-Security-Policy": "upgrade-insecure-requests"
        },
      }
    );
  }

  getAllEvents(schoolId) {
    return instance.get(`api/event/getAllEvents/${schoolId}`, {
      headers: authHeader(),
    });
  }

  addBreakDownColumnData(categoryId, eventId, playlistId) {
    return instance.post(
      "api/event/addMediaBreakdownColumn",
      { categoryId, eventId, playlistId },
      { headers: authHeader() }
    );
  }

  activityAddPost(
    categoryId,
    eventId,
    isOnPage,
    pageName,
    playlistId,
    userId,
    mediaId,
    type,
    schoolId
  ) {
    return instance.post(
      "api/event/addActivity",
      {
        categoryId,
        eventId,
        isOnPage,
        pageName,
        playlistId,
        userId,
        mediaId,
        type,
        schoolId,
      },
      { headers: authHeader() }
    );
  }

  addActivityVideoEdits(
    scheduleId,
    isOnPage,
    pageName,
    userId,
    mediaId,
    type,
    schoolId
  ) {
    return instance.post(
      "api/event/addActivity",
      {
        scheduleId,
        isOnPage,
        pageName,
        userId,
        mediaId,
        type,
        schoolId,
      },
      { headers: authHeader() }
    );
  }

  addActivityVideoShared(
    scheduleId,
    shareMediaId,
    schoolId,
    userId,
    pageName,
    type,
    shareToGroup
  ) {
    return instance.post(
      "api/event/addActivity",
      {
        scheduleId,
        shareMediaId,
        schoolId,
        userId,
        pageName,
        type,
        shareToGroup,
      },
      { headers: authHeader() }
    );
  }

  addActivitySeasonOrScheduleAdded(
    scheduleId,
    seasonId,
    schoolId,
    userId,
    pageName,
    type
  ) {
    return instance.post(
      "api/event/addActivity",
      { scheduleId, seasonId, schoolId, userId, pageName, type },
      { headers: authHeader() }
    );
  }

  addActivityMemberAdded(
    memberId,
    schoolId,
    userId,
    isOnPage,
    pageName,
    type,
    uploadId
  ) {
    return instance.post(
      "api/event/addActivity",
      { memberId, schoolId, userId, isOnPage, pageName, type, uploadId },
      { headers: authHeader() }
    );
  }

  addActivityEventAdded(eventId, schoolId, userId, isOnPage, pageName, type) {
    return instance.post(
      "api/event/addActivity",
      { eventId, schoolId, userId, isOnPage, pageName, type },
      { headers: authHeader() }
    );
  }

  saveMergehighlight(schoolId, videoName, videoUrl) {
    return instance.post(
      "api/highlight/saveMergeVideoFromHighlight",
      { schoolId, videoName, videoUrl },
      { headers: authHeader() }
    );
  }

  GetAddBreakDownColumnData(
    schoolId,
    year,
    seasonType,
    eventType,
    eventName,
    practiceName,
    opponentName
  ) {
    return instance.post(
      "api/event/getAllMediaBreakdownColumn",
      {
        schoolId,
        year,
        seasonType,
        eventType,
        eventName,
        practiceName,
        opponentName,
      },
      { headers: authHeader() }
    );
  }

  getAllMediaByPlaylist(schoolId, year, playListId) {
    return instance.post(
      "api/event/getAllMediaByPlaylist",
      {
        schoolId,
        year,
        playListId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  editBreakDownColumn(
    breakdownName,
    breakdownTypeId,
    possibleValues,
    breakdownId
  ) {
    return instance.post(
      "api/event/updateBreakdown",
      { breakdownName, breakdownTypeId, possibleValues, breakdownId },
      { headers: authHeader() }
    );
  }

  getPlayListData(
    schoolId,
    year,
    seasonType,
    eventType,
    eventName,
    practiceName,
    opponentName,
    playListId
  ) {
    return instance.post(
      "api/event/getIntercutByPlaylist",
      {
        schoolId,
        year,
        seasonType,
        eventType,
        eventName,
        practiceName,
        opponentName,
        playListId,
      },
      { headers: authHeader() }
    );
  }

  setNumberingForIntercut(categoryId, eventId, playlistId) {
    return instance.post(
      "api/event/SetNumberingIntercutByPlaylist",
      { categoryId, eventId, playlistId },
      { headers: authHeader() }
    );
  }

  getStatusSchool(id, status) {
    return instance.post(
      "api/school/updateSchoolAdminStatus",
      { id, status },
      { headers: authHeader() }
    );
  }

  activateDeactivateSchool(id, status) {
    return instance.post(
      "api/school/updateSchoolAdminStatus",
      { id, status },
      { headers: authHeader() }
    );
  }

  activateDeactivateGroup(id, status) {
    return instance.post(
      "api/group/updateGroupAdminStatus",
      { id, status },
      { headers: authHeader() }
    );
  }

  addTaglinePost(companyTagline, subTagline) {
    return instance.post(
      "api/website/addTagline",
      { companyTagline, subTagline },
      { headers: authHeader() }
    );
  }

  updateTaglinePost(companyTagline, subTagline, id) {
    return instance.post(
      "api/website/updateTagline",
      { companyTagline, subTagline, id },
      { headers: authHeader() }
    );
  }

  addCompletelyPost(details, logoId, title) {
    return instance.post(
      "api/website/addIntegrated",
      { details, logoId, title },
      { headers: authHeader() }
    );
  }

  addSportPost(details, logoId, title) {
    return instance.post(
      "api/website/addSportsAnalysis",
      { details, logoId, title },
      { headers: authHeader() }
    );
  }

  addWeekPost(title, details) {
    return instance.post(
      "api/website/addWeeks",
      { title, details },
      { headers: authHeader() }
    );
  }

  updateWeekPost(title, details, id) {
    return instance.post(
      "api/website/updateWeeks",
      { title, details, id },
      { headers: authHeader() }
    );
  }

  addSoftPost(title, details, logoId) {
    return instance.post(
      "api/website/addSoftwareStrengths",
      { title, details, logoId },
      { headers: authHeader() }
    );
  }

  addTestimonialPost(name, captian, content, logoId, testimonialsHeadingId) {
    return instance.post(
      "api/website/addTestimonials",
      { name, captian, content, logoId, testimonialsHeadingId },
      { headers: authHeader() }
    );
  }

  addTestimonialHeading(testimonialsHeading, testimonialsdetails) {
    return instance.post(
      "api/website/addTestimonialsHeading",
      { testimonialsHeading, testimonialsdetails },
      { headers: authHeader() }
    );
  }

  addCommentPost(commentMessage, schoolId, shareMediaId) {
    return instance.post(
      "api/share/addComment",
      { commentMessage, schoolId, shareMediaId },
      { headers: authHeader() }
    );
  }

  applyFilterChangesPost(
    year,
    seasonType,
    eventType,
    eventName,
    practiceName,
    opponentName,
    schoolId,
    filterId
  ) {
    return instance.post(
      "api/breakdown/applyFilter",
      {
        year,
        seasonType,
        eventType,
        eventName,
        practiceName,
        opponentName,
        schoolId,
        filterId,
      },
      { headers: authHeader() }
    );
  }

  sendLikePost(isLiked, shareMediaId) {
    return instance.post(
      "api/share/likeAndDislikeShareMedia",
      { isLiked, shareMediaId },
      { headers: authHeader() }
    );
  }

  sendBreakdownDeleteVideo(eventMediaId) {
    return instance.post(
      "api/breakdown/deleteEventMediaFromPlaylist",
      { eventMediaId },
      { headers: authHeader() }
    );
  }

  addFeaturePost(
    analysis,
    dataImports,
    kpi,
    presentations,
    review,
    teams,
    capture
  ) {
    return instance.post(
      "api/website/addFeatures",
      { analysis, dataImports, kpi, presentations, review, teams, capture },
      { headers: authHeader() }
    );
  }

  updateFeaturePost(
    analysis,
    dataImports,
    kpi,
    presentations,
    review,
    teams,
    capture,
    id
  ) {
    return instance.post(
      "api/website/updateFeatures",
      { analysis, dataImports, kpi, presentations, review, teams, capture, id },
      { headers: authHeader() }
    );
  }

  getAllCoachesDropdown(schoolId, page, size) {
    return instance.get(
      `api/coach/getCoachesOfSchools/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getCoachesList(schoolId) {
    return instance.get("api/coach/getDropdownForAddCoaches/" + schoolId, {
      headers: authHeader(),
    });
  }

  getAthletesList(schoolId) {
    return instance.get("api/athlete/getDropdownForAthlete/" + schoolId, {
      headers: authHeader(),
    });
  }

  getAllTeamDropdown(schoolId) {
    return instance.get("api/team/getAllTeamsDropdown/" + schoolId, {
      headers: authHeader(),
    });
  }

  getAllTagline() {
    return instance.get("api/website/getAllTagline", {});
  }

  getAllplaylistUploadVideo(eventId, categoryId) {
    return instance.post(
      "api/event/getPlaylistDropdown",
      {
        eventId,
        categoryId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  trendingViewPost(isViews, shareMediaId) {
    return instance.post(
      "api/share/addTrendingViewsCount",
      {
        isViews,
        shareMediaId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getAllFeatures() {
    return instance.get("api/website/getAllFeatures");
  }

  getAllPremiumWeeks() {
    return instance.get("api/website/getAllWeeks", {});
  }

  getAllNewFilter(schoolId) {
    return instance.get(`api/breakdown/getAllNewFilter/${schoolId}`, {
      headers: authHeader(),
    });
  }

  getFilterByIdPost(filterId) {
    return instance.get("api/breakdown/getFilterById/" + filterId, {
      headers: authHeader(),
    });
  }

  getAllFeatures() {
    return instance.get("api/website/getAllFeatures");
  }

  getActiveBreakDown(schoolId, columnNameId) {
    return instance.post(
      "api/event/getActiveBreakdown",
      { schoolId, columnNameId },
      {
        headers: authHeader(),
      }
    );
  }

  getHiddenBreakDown(schoolId, columnNameId) {
    return instance.post(
      "api/event/getHiddenBreakdown",
      { schoolId, columnNameId },
      {
        headers: authHeader(),
      }
    );
  }

  getDefaultBreakdownToBreakdown(schoolId) {
    return instance.post(
      "api/event/addDefaultBreakdownToBreakdown",
      { schoolId },
      {
        headers: authHeader(),
      }
    );
  }

  saveBreakdownMedia(eventId, eventMediaId, breakdownId, value, schoolId) {
    return instance.post(
      "api/event/saveBreakdownMedia",
      {
        eventId,
        eventMediaId,
        breakdownId,
        value,
        schoolId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getAllAtheleteDropdown(schoolId, page, size) {
    return instance.get(
      `api/athlete/get-atheletes-of-schools/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getAllGroupsDropdown(schoolId) {
    return instance.get(
      "api/athlete/getGroupsDropdownForAddAthlete/" + schoolId,
      {
        headers: authHeader(),
      }
    );
  }

  getAllActiveTeamAdmins(schoolId, page, size) {
    return instance.get(
      `api/coach/get-all-active-team-admin/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  deleteUploadedFile(keys, currentUserId) {
    return instance.post(
      `api/event/remove-uploaded-video-file?userId=${currentUserId}`,
      {
        keys,
      },
      {
        headers: authHeader(),
      }
    );
  }

  signUpApi(
    firstName,
    lastName,
    email,
    phoneNumber,
    country,
    state,
    schoolName,
    schoolType,
    sport,
    anyMessage,
    uploadId,
    playLevel,
    captcha
  ) {
    return instance.post(
      "api/school/addSchoolAdminWebsite",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        country,
        state,
        schoolName,
        schoolType,
        sport,
        anyMessage,
        uploadId,
        playLevel,
        captcha,
      },
      { headers: authHeader() }
    );
  }

  forgotPassword(email) {
    return instance.post(
      "api/auth/password/resetlink",
      {
        email,
      },
      { headers: authHeader() }
    );
  }
  uploadFilePost(data, option) {
    return instance.post("api/file/uploadFile", data, {
      headers: authHeader(),
      "Content-type": "multipart/form-data",
    });
  }

  uploadFilePostBilling(data, option) {
    return instance.post("api/file/billing/uploadFile", data, {
      headers: authHeader(),
      "Content-type": "multipart/form-data",
    });
  }

  uploadInvoice(data) {
    return instance.post("api/file/superAdmin/uploadFile", data, {
      headers: authHeader(),
      "Content-type": "multipart/form-data",
    });
  }

  //-------------------------------------------------------Event------------------------------------------------
  getAllEvent(schoolId) {
    return instance.get("api/event/get-events/" + schoolId, {
      headers: authHeader(),
    });
  }

  getBillingDetailsCheck(schoolId) {
    return instance.get("api/payments/getBillingValidityCheck/" + schoolId, {
      headers: authHeader(),
    });
  }

  saveEvent(
    categoryId,
    evenId,
    mediaFiles,
    playlistName,
    schoolId,
    playlistId,
    image,
    fileSize,
    videoDuration
  ) {
    return instance.post(
      "api/event/save-event-media",
      {
        categoryId,
        evenId,
        mediaFiles,
        playlistName,
        schoolId,
        playlistId,
        image,
        fileSize,
        videoDuration,
      },
      { headers: authHeader() }
    );
  }

  saveEventFromStream(
    categoryId,
    evenId,
    mediaFiles,
    playlistName,
    schoolId,
    playlistId,
    files
  ) {
    return instance.post(
      "api/event/save-live-stream-clip",
      {
        categoryId,
        evenId,
        mediaFiles,
        playlistName,
        schoolId,
        playlistId,
        files,
      },
      { headers: authHeader() }
    );
  }

  addEvent(
    eventDate,
    eventDescription,
    eventName,
    eventTime,
    lhsTeam,
    location,
    rhsTeam,
    newTeamName
  ) {
    return instance.post(
      "api/event/addEvent",
      {
        eventDate,
        eventDescription,
        eventName,
        eventTime,
        lhsTeam,
        location,
        rhsTeam,
        newTeamName,
      },
      { headers: authHeader() }
    );
  }

  addFilterPost(breakdownId, filterName, newCriteria, value, schoolId) {
    return instance.post(
      "api/breakdown/addNewFilter",
      { breakdownId, filterName, newCriteria, value, schoolId },
      { headers: authHeader() }
    );
  }

  updateFilterPost(
    breakdownId,
    filterName,
    newCriteria,
    value,
    filterId,
    schoolId
  ) {
    return instance.post(
      "api/breakdown/updateFilter",
      { breakdownId, filterName, newCriteria, value, filterId, schoolId },
      { headers: authHeader() }
    );
  }

  deleteEditedVideos(eventMediaIds) {
    return instance.post(
      "api/event/deleteEventMedia",
      { eventMediaIds },
      { headers: authHeader() }
    );
  }

  updateSuperAdminEmail(newEmail, oldEmail) {
    return instance.post(
      "api/auth/updateUserEmail",
      { newEmail, oldEmail },
      { headers: authHeader() }
    );
  }

  resetPasswordSuperAdmin(password, newPassword, confirmPassword) {
    return instance.post(
      "api/admin/resetWithNewPassowrd",
      { password, newPassword, confirmPassword },
      { headers: authHeader() }
    );
  }

  addSignUp(
    firstName,
    lastName,
    email,
    phoneNumber,
    country,
    state,
    schoolName,
    schoolType,
    sport,
    anyMessage,
    uploadId
  ) {
    return instance.post(
      "api/global/addSchoolAdminWebsite",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        country,
        state,
        schoolName,
        schoolType,
        sport,
        anyMessage,
        uploadId,
      },
      { headers: authHeader() }
    );
  }
  addSchoolAdmin(
    firstName,
    lastName,
    email,
    phoneNumber,
    country,
    plan,
    state,
    schoolType,
    schoolName,
    sport,
    playLevel,
    uploadId,
    profileId
  ) {
    return instance.post(
      "api/admin/addSchoolAdmin",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        country,
        plan,
        state,
        schoolType,
        schoolName,
        sport,
        playLevel,
        uploadId,
        profileId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  editSchoolAdmin(
    firstName,
    lastName,
    email,
    id,
    phoneNumber,
    country,
    state,
    status,
    uploadId,
    profileId,
    plan,
    schoolName,
    schoolType,
    sport,
    playLevel
  ) {
    return instance.post(
      "api/admin/updateSchoolAdmin",
      {
        firstName,
        lastName,
        email,
        id,
        phoneNumber,
        country,
        state,
        status,
        uploadId,
        profileId,
        plan,
        schoolName,
        schoolType,
        sport,
        playLevel,
      },
      {
        headers: authHeader(),
      }
    );
  }

  deleteSchoolId(schoolId) {
    return instance.post("api/school/deleteSchool", schoolId, {
      headers: authHeader(),
    });
  }

  deleteFilterId(ids) {
    return instance.post("api/breakdown/deleteNewFilter", ids, {
      headers: authHeader(),
    });
  }

  deletebreakDownId(id) {
    return instance.post("api/event/deleteBrekdownPermanently", id, {
      headers: authHeader(),
    });
  }

  resetSchoolLink(emails) {
    return instance.post("api/auth/password/resetlink", emails, {
      headers: authHeader(),
    });
  }

  resetSchoolLinkShort(email) {
    return instance.post(
      "api/auth/password/resetlink",
      { email },
      {
        headers: authHeader(),
      }
    );
  }

  //--------------------------------coach----------------------------------------------------------------
  editCoachDetails(
    firstName,
    lastName,
    email,
    phoneNumber,
    specialty,
    id,
    uploadedId,
    schoolId,
    groupIds,
    teamIds,
    sportIds,
    permissionRights
  ) {
    return instance.post(
      "api/admin/updateCoach",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        specialty,
        id,
        uploadedId,
        schoolId,
        groupIds,
        teamIds,
        sportIds,
        permissionRights,
      },
      {
        headers: authHeader(),
      }
    );
  }

  addCouches(
    firstName,
    lastName,
    email,
    phoneNumber,
    specialty,
    uploadId,
    schoolId,
    groupIds,
    permissionRights
  ) {
    return instance.post(
      "api/coach/add-coach",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        specialty,
        uploadId,
        schoolId,
        groupIds,
        permissionRights,
      },
      {
        headers: authHeader(),
      }
    );
  }
  deleteCoachById(ids) {
    return instance.post("api/admin/deleteCoach", ids, {
      headers: authHeader(),
    });
  }
  //-----------------------------------------------Athletes---------------------------------------------------

  deleteAtheleteById(ids) {
    return instance.post("api/admin/deleteAthlete", ids, {
      headers: authHeader(),
    });
  }

  editAthleteDetails(
    firstName,
    lastName,
    email,
    phoneNumber,
    positionPlayed,
    graduationYear,
    uploadId,
    id,
    jerseyNumber,
    schoolId,
    groupIds,
    instagramLink,
    twitterLink
  ) {
    return instance.post(
      "api/admin/updateAthlete",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        positionPlayed,
        graduationYear,
        uploadId,
        id,
        jerseyNumber,
        schoolId,
        groupIds,
        instagramLink,
        twitterLink,
      },
      {
        headers: authHeader(),
      }
    );
  }

  AddAthleteDetails(
    firstName,
    lastName,
    email,
    phoneNumber,
    jerseyNumber,
    positionPlayed,
    group,
    uploadId,
    graduationYear,
    schoolId,
    groupIds,
    teamIds,
    instagramLink,
    twitterLink,
    sportIds
  ) {
    return instance.post(
      "api/athlete/add-athlete",
      {
        firstName,
        lastName,
        email,
        phoneNumber,
        jerseyNumber,
        positionPlayed,
        group,
        uploadId,
        graduationYear,
        schoolId,
        groupIds,
        teamIds,
        instagramLink,
        twitterLink,
        sportIds,
      },
      {
        headers: authHeader(),
      }
    );
  }

  addAthleteCsv(csvData) {
    return instance.post("api/athlete/add-bulk-athlete", csvData, {
      headers: authHeader(),
    });
  }

  AddAthleteDetailsWebsite(addAthleteRequest, token) {
    return instance.post("api/school/add-athelete-from-invite", {
      addAthleteRequest,
      token,
    });
  }

  //-------------------------------------------------Teams-----------------------------------------------------
  AddTeamDetails(coaches, athletes, schoolId, teamName, uploadId) {
    return instance.post(
      "api/team/add-team",
      {
        coaches,
        athletes,
        schoolId,
        teamName,
        uploadId,
      },
      { headers: authHeader() }
    );
  }

  editTeamsDetails(athletes, coaches, schoolId, teamName, teamId, uploadId) {
    return instance.post(
      "api/team/update-team",
      {
        athletes,
        coaches,
        schoolId,
        teamName,
        teamId,
        uploadId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getTeamsDetails(id) {
    return instance.get("api/team/get-team-by-id/" + id, {
      headers: authHeader(),
    });
  }

  getTeamsDropdown(id) {
    return instance.get("api/team/getAllTeamsDropdown/" + id, {
      headers: authHeader(),
    });
  }

  //----------------------------------------------------------Events------------------------------------------------------
  getEventDetails() {
    return instance.get("api/event/get-events", {
      headers: authHeader(),
    });
  }

  getEventList() {
    return instance.get("/api/event/getAllEventListing", {
      headers: authHeader(),
    });
  }

  getPastEventListing(schoolId) {
    return instance.get("api/event/getAllPastEvent/" + schoolId, {
      headers: authHeader(),
    });
  }

  getPastEventByPage(schoolId, page, size) {
    return instance.get(
      `api/event/getAllPastEvent/${schoolId}?size=${size}&page=${page}`,
      {
        headers: authHeader(),
      }
    );
  }
  getCurrentEventByPage(schoolId, page, size) {
    return instance.get(
      `api/event/getAllUpcommingEvent/${schoolId}?size=${size}&page=${page}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchCurrentEvent(query, schoolId, page, size) {
    return instance.get(
      `api/event/searchAllUpcomingEvent/${query}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchPastEvent(query, schoolId, page, size) {
    return instance.get(
      `api/event/searchAllUpcomingEvent/${query}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getUpcomingEventListing(schoolId) {
    return instance.get("api/event/getAllUpcommingEvent/" + schoolId, {
      headers: authHeader(),
    });
  }

  createEventAdd(
    eventDate,
    eventDescription,
    eventName,
    eventTime,
    location,
    school1Id,
    school2Name,
    eventType,
    schoolId,
    newTeamName,
    userId
  ) {
    return instance.post(
      "api/event/addEvent",
      {
        eventDate,
        eventDescription,
        eventName,
        eventTime,
        location,
        school1Id,
        school2Name,
        eventType,
        schoolId,
        newTeamName,
        userId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  EventEdit(
    eventDate,
    eventDescription,
    eventName,
    eventTime,
    eventType,
    location,
    school1_Id,
    school2Name,
    id,
    schoolId,
    team1Score,
    team2Score,
    newTeamName,
    sportId
  ) {
    return instance.post(
      "api/event/updateEvent",
      {
        eventDate,
        eventDescription,
        eventName,
        eventTime,
        eventType,
        location,
        school1_Id,
        school2Name,
        id,
        schoolId,
        team1Score,
        team2Score,
        newTeamName,
        sportId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getEventDetailsEdit(id) {
    return instance.get("api/event/getEventById/" + id, {
      headers: authHeader(),
    });
  }

  deleteVideoEvent(id) {
    return instance.post(
      "api/event/deleteEvent",
      {
        id,
      },
      {
        headers: authHeader(),
      }
    );
  }
  //---------------------------------------------------Groups-------------------------------------------------
  addGroups(groupName, coaches, athletes, teamAdmin, schoolId, uploadId) {
    return instance.post(
      "api/group/addGroup",
      {
        groupName,
        coaches,
        athletes,
        teamAdmin,
        schoolId,
        uploadId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  editGroups(
    groupName,
    coaches,
    athletes,
    teamAdmin,
    schoolId,
    uploadId,
    groupId
  ) {
    return instance.post(
      "api/group/updateGroup",
      {
        groupName,
        coaches,
        athletes,
        teamAdmin,
        schoolId,
        uploadId,
        groupId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getAllGroups(schoolId) {
    return instance.get("api/group/getAllGroups/" + schoolId, {
      headers: authHeader(),
    });
  }

  deleteGroupsApi(groupId) {
    return instance.delete("api/group/deleteGroupById/" + groupId, {
      headers: authHeader(),
    });
  }

  deleteTeamsApi(teamId) {
    return instance.delete("api/team/delete-team-by-id/" + teamId, {
      headers: authHeader(),
    });
  }

  // annotationBase64Post(base64) {
  //   return instance.post(
  //      "api/file/upload-encoded-file",
  //     { base64},
  //     { headers: authHeader() }
  //   );
  // }

  annotationBase64Post(base64) {
    return instance.post(
      "/api/file/upload-encoded-file",
      { base64 },
      {
        headers: authHeader(),
      }
    );
  }

  getAllWebsiteEnquiries() {
    return instance.get("api/website/getAllWebsiteEnquiries", {
      headers: authHeader(),
    });
  }

  getAllWebsiteEnquiriesByPage(page, size) {
    return instance.get(
      `api/website/getAllWebsiteEnquiries?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  addWebsiteContactUs(heading, subHeading) {
    return instance.post(
      "api/website/addWebsiteContactUs",
      { heading, subHeading },
      { headers: authHeader() }
    );
  }

  getAllWebsiteContactUs() {
    return instance.get("api/website/getAllWebsiteContactUs", {
      headers: authHeader(),
    });
  }

  updateWebsiteContactUs(heading, subHeading, id) {
    return instance.post(
      "api/website/updateWebsiteContactUs",
      { heading, subHeading, id },
      { headers: authHeader() }
    );
  }

  // getAllBillingSchool(schoolId) {
  //     return instance.get( "api/payments/getBillingBySchool/"+schoolId, {
  //     headers: authHeader(),
  //   });
  // }

  getLiveEventDropdown(schoolId) {
    return instance.get("api/event/getLiveEventDropdown/" + schoolId, {
      headers: authHeader(),
    });
  }

  getPaymentStausWiseCount() {
    return instance.get("api/payments/getPaymentStausWiseCount", {
      headers: authHeader(),
    });
  }

  getMostUsedSchool() {
    return instance.get("api/dashboard/getMostActiveSchools", {
      headers: authHeader(),
    });
  }

  getMostUsedSchoolFeature() {
    return instance.get("api/dashboard/getMostUsedFeatures", {
      headers: authHeader(),
    });
  }

  getAllIntegration() {
    return instance.get("api/website/getAllIntegrated", {});
  }

  updateIntegrated(details, logoId, title, id) {
    return instance.post(
      "api/website/updateIntegrated",
      { details, logoId, title, id },
      { headers: authHeader() }
    );
  }

  updateSportsAnalysisWeb(details, logoId, title, id) {
    return instance.post(
      "api/website/updateSportsAnalysis",
      { details, logoId, title, id },
      { headers: authHeader() }
    );
  }

  getSoftwareStrengths() {
    return instance.get("api/website/getAllSoftwareStrengths", {});
  }

  updateSoftwareStrengthsWeb(details, id, logoId, title) {
    return instance.post(
      "api/website/updateSoftwareStrengths",
      { details, id, logoId, title },
      { headers: authHeader() }
    );
  }

  getSportsAnalysis() {
    return instance.get("api/website/getAllSportsAnalysis");
  }

  getTestimonials() {
    return instance.get("api/website/getAllTestimonials");
  }

  getTestimonialsHeading() {
    return instance.get("api/website/getAllTestimonialHeading");
  }

  updateTestimonialsWeb(
    captian,
    content,
    id,
    logoId,
    name,
    testimonialsHeadingId
  ) {
    return instance.post(
      "/api/website/updateTestimonials",
      { captian, content, id, logoId, name, testimonialsHeadingId },
      { headers: authHeader() }
    );
  }
  updateTestimonialsHeading(id, testimonialsdetails, testimonialsHeading) {
    return instance.post(
      "/api/website/updateTestimonialsHeading",
      { id, testimonialsdetails, testimonialsHeading },
      { headers: authHeader() }
    );
  }

  deleteHighlight(id) {
    return instance.post(
      "api/highlight/deleteHighlighted",
      { id },
      {
        headers: authHeader(),
      }
    );
  }

  highlighteSearch(searchString) {
    return instance.get("api/highlight/searchHighlighted/" + searchString, {
      headers: authHeader(),
    });
  }

  highlighsViewsCount(highlightId, isViews) {
    return instance.post(
      "api/highlight/addHighlighsViewsCount",
      {
        highlightId,
        isViews,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getStorageCountSADashboard() {
    return instance.get("api/dashboard/getStorageCount", {
      headers: authHeader(),
    });
  }

  getAllSchoolStorage() {
    return instance.get("api/storage/getAllStorage", {
      headers: authHeader(),
    });
  }

  deleteFAQsdata(id) {
    return instance.post(
      "api/website/deleteFAQs",
      { id },
      {
        headers: authHeader(),
      }
    );
  }

  deleteProductVideos(id) {
    return instance.post(
      "api/website/deleteProductRelatedVideos",
      { id },
      {
        headers: authHeader(),
      }
    );
  }

  getSoftwareStrengthsById(SoftwareStrengthsId) {
    return instance.get(
      "api/website/getSoftwareStrengthsById/" + SoftwareStrengthsId,
      {
        headers: authHeader(),
      }
    );
  }

  deletePayments(id) {
    return instance.post(
      "api/payments/deleteBilling",
      { id },
      {
        headers: authHeader(),
      }
    );
  }

  editPayments(
    amount,
    id,
    note,
    paymentMethod,
    paymentStatus,
    schoolId,
    uploadFilesInvoiceId,
    validityDate
  ) {
    return instance.post(
      "api/payments/updateBilling",
      {
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate,
      },
      { headers: authHeader() }
    );
  }

  deleteContactUsEnquiriesById(id) {
    return instance.post(
      "/api/website/deleteWebsiteEnquiries",
      { id },
      {
        headers: authHeader(),
      }
    );
  }

  // ////events/////
  getAllEvents(schoolId) {
    return instance.get(`api/event/getAllEvents/${schoolId}`, {
      headers: authHeader(),
    });
  }

  deletePlaylistVideo(eventMediaIds, userId, authorization) {
    return superagent
      .delete(`/api/event/admin/deleteAllEventMedia?userId=${userId}`, {
        eventMediaIds,
      })
      .send({ eventMediaIds: eventMediaIds })
      .set({
        Authorization: authorization,
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        "Accept-Encoding": "gzip, deflate, br",
        "Accept-Language": "en-US,en;q=0.5",
        Host: "devapi.contendzone.com",
      });
  }

  getAllDeletedMedia(userId, page, size) {
    return instance.get(
      `api/event/media/getAllDeletedMedia/?userId=${userId}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchDeletedMedia(userId, page, size) {
    return instance.get(
      `api/event/admin/getAllDeletedMedia?userId=${userId}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  restoredDeletedNedia(eventMediaIds) {
    return instance.post(
      "api/event/admin/restoredEventMedia",
      { eventMediaIds },
      {
        headers: authHeader(),
      }
    );
  }

  getStorageDetails(userId) {
    return instance.get(
      `api/event/admin/getStorageAndDuration?userId=${userId}`,
      {
        headers: authHeader(),
      }
    );
  }

  addSport(uploadId, playLevel, sportName) {
    return instance.post(
      "api/school/addSport",
      { uploadId, playLevel, sportName },
      {
        headers: authHeader(),
      }
    );
  }

  getSports(schoolId) {
    return instance.get(`api/school/getListAllSports/${schoolId}`, {
      headers: authHeader(),
    });
  }

  getSportById(id, schoolId) {
    return instance.get(
      `api/school/getSportById?sportId=${id}&schoolId=${schoolId}`,
      {
        headers: authHeader(),
      }
    );
  }

  updateSport(id, uploadId, playLevel, sportName, schoolId) {
    return instance.post(
      "api/school/updateSport",
      { id, uploadId, playLevel, sportName, schoolId },
      {
        headers: authHeader(),
      }
    );
  }

  getActivityHistory(type, schoolId, page, size) {
    return instance.get(
      `api/event/getAllActivityFilter?type=${type}&schoolId=${schoolId}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getAllPermissions() {
    return instance.get("api/coach/getAllPermissionRights", {
      headers: authHeader(),
    });
  }

  getStatusTeamAdmin(id, status) {
    return instance.post(
      `api/coach/changeTeamAdminStatus/${id}?isActivated=${status}`,
      { id, status },
      { headers: authHeader() }
    );
  }

  changeCoachStatus(id, status) {
    return instance.post(
      `api/coach/changeCoachStatus/${id}?isActivated=${status}`,
      { id, status },
      { headers: authHeader() }
    );
  }

  changeAthleteStatus(id, status) {
    return instance.post(
      `api/athlete/changeAthleteStatus/${id}?isActivated=${status}`,
      { id, status },
      { headers: authHeader() }
    );
  }

  getAllTeamAdmins(schoolId) {
    return instance.get(`api/coach/get-all-team-admin/${schoolId}`, {
      headers: authHeader(),
    });
  }

  getTeamAdminById(id) {
    return instance.get(`api/coach/get-team-admin/${id}`, {
      headers: authHeader(),
    });
  }

  deleteTeamAdmin(ids) {
    return instance.post(
      `/api/coach/deleteTeamAdmin`,
      { ids },
      {
        headers: authHeader(),
      }
    );
  }

  addTeamAdmin(
    uploadId,
    firstName,
    lastName,
    email,
    phoneNumber,
    specialty,
    groupIds,
    schoolId,
    permissionRights,
    sportIds
  ) {
    return instance.post(
      "api/coach/add-team-admin",
      {
        uploadId,
        firstName,
        lastName,
        email,
        phoneNumber,
        specialty,
        groupIds,
        schoolId,
        permissionRights,
        sportIds,
      },
      {
        headers: authHeader(),
      }
    );
  }

  editTeamAdmin(
    id,
    uploadedId,
    firstName,
    lastName,
    email,
    phoneNumber,
    specialty,
    groupIds,
    schoolId,
    permissionRights,
    sportIds
  ) {
    return instance.post(
      "api/coach/updateTeamAdmin",
      {
        id,
        uploadedId,
        firstName,
        lastName,
        email,
        phoneNumber,
        specialty,
        groupIds,
        schoolId,
        permissionRights,
        sportIds,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getTeamAdminSchoolDetails() {
    return instance.get("api/event/getTeamAdminSchools", {
      headers: authHeader(),
    });
  }

  getAllAthleteByFilter(id, sportName) {
    const url =
      sportName === undefined || sportName === "Select Sport"
        ? `api/athlete/get-all-athelets-by-coach/${id}`
        : `api/athlete/get-all-athelets-by-coach/${id}?sportName=${sportName}`;

    return instance.get(url, {
      headers: authHeader(),
    });
  }

  getAllAthleteByPage(id, page, size) {
    return instance.get(
      `api/athlete/get-all-athelets-by-coach/${id}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  approveBreakdownRequest(id) {
    return instance.post(
      `api/event/approveBreakdownRequestChange/${id}`,
      {},
      {
        headers: authHeader(),
      }
    );
  }

  disApproveBreakdownRequest(id) {
    return instance.post(
      `api/event/disApproveBreakdownRequestChange/${id}`,
      {},
      {
        headers: authHeader(),
      }
    );
  }

  searchBreakdownRequest(searchKeyword) {
    return instance.get(
      `api/event/getAllBreakdownRequestChanges?searchString=${searchKeyword}`,
      { headers: authHeader() }
    );
  }

  deleteBreakdownRequest(id) {
    return instance.delete(`api/event/deleteBreakdownRequestChange/${id}`, {
      headers: authHeader(),
    });
  }

  getAllTeamAdminsByPage(id, page, size) {
    return instance.get(
      `api/coach/get-all-team-admin/${id}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getBreakdownRequestsByPage(page, size) {
    return instance.get(
      `api/event/getAllBreakdownRequestChanges?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getAllCoachesByPage(id, page, size) {
    return instance.get(
      `api/coach/get-all-coaches-by-school/${id}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getAllCoachesByFilter(schoolId, sportName) {
    const url =
      sportName === undefined || sportName === "Select Sport"
        ? `api/coach/get-all-coaches-by-school/${schoolId}`
        : `api/coach/get-all-coaches-by-school/${schoolId}?sportName=${sportName}`;

    return instance.get(url, {
      headers: authHeader(),
    });
  }

  getAllSportsHoursDetails(schoolId) {
    return instance.get(
      `api/dashboard/getSportDurationGraphData?schoolId=${schoolId}`,
      {
        headers: authHeader(),
      }
    );
  }

  addHoursRequest(id, addHours) {
    return instance.post(
      `api/dashboard/buySportHours?sportId=${id}&hours=${addHours}`,
      {},
      {
        headers: authHeader(),
      }
    );
  }
  getAddHoursRequest() {
    return instance.get("api/dashboard/pendingSportHoursRequest", {
      headers: authHeader(),
    });
  }

  approveHoursRequest(id) {
    return instance.post(
      `api/dashboard/approveSportHours/${id}`,
      {},
      {
        headers: authHeader(),
      }
    );
  }
  disApproveHoursRequest(id) {
    return instance.delete(`api/dashboard/deleteSportHours/${id}`, {
      headers: authHeader(),
    });
  }

  searchAthletes(query, schoolId, page, size) {
    return instance.get(
      `api/admin/searchAthletes/${query}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchCoaches(query, schoolId, page, size) {
    return instance.get(
      `api/admin/searchCoaches/${query}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchTeamAdmin(query, schoolId, page, size) {
    return instance.get(
      `api/admin/searchTeamAdmins/${query}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getCoachesAthleteCountForMainPage() {
    return instance.get("api/website/getSchoolAthleteCoachesStorageCount");
  }

  addWebsiteVisitor(token) {
    return instance.post(`api/website/visitWebsite`, {
      token: token,
    });
  }

  getWebsiteVisitorsCountByDate(startDate, endDate) {
    return instance.get(
      `api/website/getAllVisitWebsite/0?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getWebsiteVisitorsCount(number) {
    return instance.get(`api/website/getAllVisitWebsite/${number}`);
  }

  getGroupsByPage(schoolId, page, size) {
    return instance.get(
      `api/group/getAllGroups/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchGroups(query, schoolId, page, size) {
    return instance.get(
      `api/group/searchGroups/${query}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getSchoolsByPage(page, size) {
    return instance.get(
      `api/school/getAllSchoolsDropdownWithPaging?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchSchool(query, page, size) {
    return instance.get(
      `api/school/searchSchools/${query}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchPayment(query, page, size) {
    return instance.get(
      `api/payments/searchPaymentHistory/${query}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchPaymentHistory(query, page, size) {
    return instance.get(
      `api/payments/getAllBilling?schoolName=${query}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
    //api/payments/getAllBilling?schoolName=St. Francis High School
  }

  searchWebsiteEnquiries(query, page, size) {
    return instance.get(
      `api/website/searchWebsiteEnquiries/${query}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchStorageData(query) {
    return instance.get(
      `api/dashboard/pendingSportHoursRequest?schoolName=${query}`,
      {
        headers: authHeader(),
      }
    );
  }

  activeColumnsDragAndDrop(request) {
    return instance.post(
      `api/event/dragAndDropBreakdownByPosition`,
      {
        request,
      },
      {
        headers: authHeader(),
      }
    );
  }

  hiddenColumnDragAndDrop(request) {
    return instance.post(
      `api/event/dragAndDropHiddenBreakdownByPosition`,
      {
        request,
      },
      {
        headers: authHeader(),
      }
    );
  }

  renameVideo(id, name, schoolId) {
    return instance.post(
      `api/event/updateMediaCategoryName`,
      {
        id: id,
        eventMediaCategoryName: name,
        schoolId: schoolId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  deleteVideoById(id) {
    return instance.delete(`api/event/deleteMedia/${id}`, {
      headers: authHeader(),
    });
  }

  getAllUnreadNotifications() {
    return instance.get("api/notify/get-unread-notifications", {
      headers: authHeader(),
    });
  }

  addNewsLetter(email) {
    return instance.post(`api/website/addNewsLetters`, { email });
  }

  getAllNewsLetters(page, size) {
    return instance.get(
      `api/website/getAllNewsLetters?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  restoreSchool(schoolId) {
    return instance.post("api/school/restoreSchool", schoolId, {
      headers: authHeader(),
    });
  }

  createSeason(schoolId, year, currentSeason) {
    return instance.post(
      "api/event/addSeason",
      { schoolId, year, currentSeason },
      {
        headers: authHeader(),
      }
    );
  }

  updateSeason(id, schoolId, year, currentSeason) {
    return instance.post(
      "api/event/updateSeason",
      { id, schoolId, year, currentSeason },
      {
        headers: authHeader(),
      }
    );
  }

  getCurrentSeason(schoolId) {
    return instance.get(`api/event/getCurrentSeason/${schoolId}`, {
      headers: authHeader(),
    });
  }

  getAllSeasonWeeks(schoolId, seasonId) {
    return instance.get(`api/school/getSeasonWeeks/${schoolId}/${seasonId}`, {
      headers: authHeader(),
    });
  }

  getAllSeasonWeeksBySize(schoolId, size, seasonId) {
    return instance.get(
      `api/school/getSeasonWeeks/${schoolId}/${seasonId}/?weekLimit=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  createSchedule(
    seasonType,
    eventType,
    location,
    uiEventDate,
    uiEventTime,
    schoolId,
    opponent,
    seasonId,
    seasonWeekId
  ) {
    return instance.post(
      "api/school/createSchedule",
      {
        seasonType,
        eventType,
        location,
        uiEventDate,
        uiEventTime,
        schoolId,
        opponent,
        seasonId,
        seasonWeekId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  editSchedule(
    id,
    seasonType,
    eventType,
    location,
    uiEventDate,
    uiEventTime,
    schoolId,
    opponent,
    seasonId,
    seasonWeekId
  ) {
    return instance.post(
      "api/school/editSchedule",
      {
        id,
        seasonType,
        eventType,
        location,
        uiEventDate,
        uiEventTime,
        schoolId,
        opponent,
        seasonId,
        seasonWeekId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getSchedules(schoolId, page, size) {
    return instance.get(
      `api/school/getSchedule/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchSchedule(query, schoolId, page, size) {
    return instance.get(
      `api/school/searchSchedule/${schoolId}/${query}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }
  saveScheduleEvent(
    eventType,
    schoolId,
    eventName,
    practiceName,
    mediaFiles,
    seasonType,
    scheduleId,
    isPractice,
    seasonId,
    isEdited,
    playListId,
    isStreamedVideo
  ) {
    return instance.post(
      `api/event/save-schedule-event`,
      {
        eventType,
        schoolId,
        eventName,
        practiceName,
        mediaFiles,
        seasonType,
        scheduleId,
        isPractice,
        seasonId,
        isEdited,
        playListId,
        isStreamedVideo,
      },
      {
        headers: authHeader(),
      }
    );
  }

  saveScheduleEventForVideoEditing(
    eventType,
    schoolId,
    eventName,
    practiceName,
    mediaFiles,
    seasonType,
    scheduleId,
    isPractice,
    seasonId,
    isEdited,
    playListId,
    isStreamedVideo
  ) {
    return instance.post(
      `api/event/save-schedule-event`,
      {
        eventType,
        schoolId,
        eventName,
        practiceName,
        mediaFiles,
        seasonType,
        scheduleId,
        isPractice,
        seasonId,
        isEdited,
        playListId,
        isStreamedVideo,
      },
      {
        headers: authHeader(),
      }
    );
  }

  fetchScheduleMedia(mediaId) {
    return instance.get(`api/event/get-schedule-media/${mediaId}`, {
      headers: authHeader(),
    });
  }

  updateMediaVideoUrl(
    eventMediaId,
    videoUrl,
    videoDuration,
    fileSize,
    eventMediaCategory
  ) {
    return instance.post(
      `api/event/updateMediaVideoUrl`,
      [
        {
          eventMediaId,
          videoUrl,
          videoDuration,
          fileSize,
          eventMediaCategory,
        },
      ],
      {
        headers: authHeader(),
      }
    );
  }
  fetchEventNames(schoolId) {
    return instance.get(`api/event/getScheduleEventName/${schoolId}`, {
      headers: authHeader(),
    });
  }

  createEventName(name, schoolId) {
    return instance.post(
      `api/event/createEventName`,
      {
        name,
        schoolId,
      },
      {
        headers: authHeader(),
      }
    );
  }

  createPlaylist({
    schoolId,
    seasonId,
    scheduleId,
    playlistName,
    categoryId,
    seasonType,
    eventName,
    practiceName,
    scheduleEventId,
    isPractice,
  }) {
    return instance.post(
      `api/event/addPlaylist`,
      {
        schoolId,
        seasonId,
        scheduleId,
        playlistName,
        categoryId,
        seasonType,
        eventName,
        practiceName,
        scheduleEventId,
        isPractice,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getPlaylistName({
    scheduleId,
    seasonId,
    categoryId,
    schoolId,
    scheduleEventId,
    seasonType,
    eventName,
    practiceName,
    isPractice,
  }) {
    return instance.post(
      `api/event/getAllPlaylistDropdown`,
      {
        categoryId,
        scheduleId,
        seasonId,
        schoolId,
        scheduleEventId,
        seasonType,
        eventName,
        practiceName,
        isPractice,
      },
      { headers: authHeader() }
    );
  }

  fetchScheduleList(schoolId) {
    return instance.get(`api/school/getScheduleEventList/${schoolId}`, {
      headers: authHeader(),
    });
  }

  searchSport(query, schoolId, page, size) {
    return instance.get(`api/school/searchSport/${schoolId}/${query}`, {
      headers: authHeader(),
    });
  }

  searchBreakDownData(query, schoolId, page, size, defaultColumnSetName) {
    return instance.get(
      `api/event/searchBreakdown/${schoolId}?searchString=${query}&columnName=${defaultColumnSetName}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  deleteVideoPermanently(eventMediaIds, userId) {
    return instance.delete(
      `api/event/admin/permanentDeleteEventMedia?userId=${userId}`,
      {
        data: { eventMediaIds: eventMediaIds },
        headers: authHeader(),
      }
    );
  }

  searchVideos(userId, searchString, page, size) {
    return instance.get(
      `api/event/media/getAllDeletedMedia?userId=${userId}&searchString=${searchString}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchColumnSet(searchString, schoolId) {
    return instance.get(
      `api/breakdown/columName/${schoolId}?searchString=${searchString}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchHiddenColumn(searchString, schoolId, columnNameId) {
    return instance.get(
      `api/event/searchHiddenBreakdown/${schoolId}?searchString=${searchString}&columnNameId=${columnNameId}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchActiveColumnBreakdown(searchString, schoolId, columnNameId) {
    return instance.get(
      `api/event/searchActiveBreakdown/${schoolId}?searchString=${searchString}&columnNameId=${columnNameId}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchActiveCoaches(searchString, schoolId, page, size) {
    return instance.get(
      `api/coach/get-active-coach-by-school/${schoolId}?searchString=${searchString}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchActiveAthletes(searchString, schoolId, page, size) {
    return instance.get(
      `api/athlete/get-active-athlete-by-school/${schoolId}?searchString=${searchString}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchActiveTeamAdmins(searchString, schoolId, page, size) {
    return instance.get(
      `api/admin/searchTeamAdmins/${searchString}/schoolId/${schoolId}?isActive=${true}&page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  getScheduleDetailsOfEventMedia(id) {
    return instance.get(`api/event/getMediaScheduleEventWeek/${id}`, {
      headers: authHeader(),
    });
  }

  getActiveGroups(schoolId, page, size) {
    return instance.get(
      `api/group/getAllActiveGroups/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  searchActiveGroups(searchString, schoolId, page, size) {
    return instance.get(
      `api/group/searchActiveGroups/${searchString}/schoolId/${schoolId}?page=${page}&size=${size}`,
      {
        headers: authHeader(),
      }
    );
  }

  addStreamingChannelDetail(
    name,
    channelId,
    streamUrl,
    state,
    rtmpPushURL1,
    rtmpPushURL2
  ) {
    return instance.post(
      "api/channel/addStreamingChannelDetail",
      {
        name,
        channelId,
        streamUrl,
        state,
        rtmpPushURL1,
        rtmpPushURL2,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getChannelDetails() {
    return instance.get("api/channel/getAllChannelDetails", {
      headers: authHeader(),
    });
  }

  getIVSChannelDetailsForSuperAdmin() {
    return instance.get("api/channel/angle/getIVSChannelDetails", {
      headers: authHeader(),
    });
  }

  getPastIVSChannelForSuperAdmin(page, size, filter) {
    return instance.get(
      `api/channel/angle/getPastIVSChannelDetails?page=${page}&size=${size}&type=${filter}`,
      {
        headers: authHeader(),
      }
    );
  }

  checkVideoStream(token) {
    return instance.post(`api/website/liveStreaming&token=${token}`, {
      headers: authHeader(),
    });
  }

  startVideoStream(channelIds) {
    return instance.post(`api/channel/startStreamingChannel`, channelIds, {
      headers: authHeader(),
    });
  }

  stopVideoStream(channelIds) {
    return instance.post(`api/channel/stopStreamingChannel`, channelIds, {
      headers: authHeader(),
    });
  }

  getAllAvsChannelList(schoolId) {
    return instance.get(`api/website/getAllIVSChannelDetails/${schoolId}`, {
      headers: authHeader(),
    });
  }

  createChannel(channelName, angleName) {
    return axios.post(
      NODE_BASE_URL + "/stream/createChannel",
      { channelName, angleName },
      {
        headers: authHeader(),
      }
    );
  }

  createStage(stageName, userId) {
    return axios.post(
      NODE_BASE_URL + "/realTimeStream/createStage",
      { stageName, userId },
      {
        headers: authHeader(),
      }
    );
  }

  checkStageStatus(stageArn) {
    return axios.post(
      NODE_BASE_URL + "/realTimeStream/stageStatus",
      { stageArn },
      {
        headers: authHeader(),
      }
    );
  }

  deleteStageRealTimeStream(stageArn) {
    return axios.post(
      NODE_BASE_URL + "/realTimeStream/deleteStage",
      {
        stageArn,
      },
      {
        headers: authHeader(),
      }
    );
  }

  generatePubSubToken(userId, stageArn) {
    return axios.post(
      NODE_BASE_URL + "/realTimeStream/generatePubSubToken",
      {
        userId,
        stageArn,
      },
      {
        headers: authHeader(),
      }
    );
  }

  deleteChannel(channelArns) {
    return axios.post(
      NODE_BASE_URL + `/stream/deleteChannel`,
      {
        channelArns,
      },
      {
        headers: authHeader(),
      }
    );
  }

  stopIvsStream(channelArns) {
    return axios.post(
      NODE_BASE_URL + `/stream/stopIvsStream`,
      {
        channelArns,
      },
      {
        headers: authHeader(),
      }
    );
  }

  getRecordedClip({ recordingData, byteRange, elapsedTime }) {
    return axios.post(
      NODE_BASE_URL + `/stream/getRecordedClip`,
      { recordingData, byteRange, duration: elapsedTime },
      {
        headers: authHeader(),
      }
    );
  }

  getStreamMetadata({ channelArn }) {
    return axios.post(
      NODE_BASE_URL + "/stream/getStreamMetadata",
      {
        channelArn,
      },
      {
        headers: authHeader(),
      }
    );
  }

  updateStreamingStartTime({ id, streamingStartTime }) {
    return instance.post(
      BASE_URL + `api/channel/updateStreamingStartTime`,
      {
        id,
        streamingStartTime,
      },
      {
        headers: authHeader(),
      }
    );
  }

  addAvsChannel(payload) {
    return instance.post("api/channel/addIVSChannelDetail", payload, {
      headers: authHeader(),
    });
  }

  updateChannelStatus(data) {
    return instance.put("api/channel/updateIVSChannelDetail", data, {
      headers: authHeader(),
    });
  }

  fetchAllLiveChannelDetails() {
    return instance.get("/api/website/getAllIVSChannelDetails");
  }

  requestCameraConnection(username, password, ipAddress) {
    return instance.post(
      NODE_BASE_URL + "/stream/startStream",
      {
        username,
        password,
        ipAddress,
      },
      { headers: authHeader() }
    );
  }

  updateContactUsResolvedStatus(id, resolved) {
    return instance.put(
      `api/website/updateResolvedStatus?id=${id}&isResolved=${resolved}`,
      null,
      {
        headers: authHeader(),
      }
    );
  }

  addBreakDownValuesToTable(arr) {
    return instance.post("api/event/saveAllBreakdownMedia", arr, {
      headers: authHeader(),
    });
  }

  getDefaultODKBreakdownData(schoolId) {
    return instance.get(`api/event/getDefaultODKBreakdown/${schoolId}`, {
      headers: authHeader(),
    });
  }

  getAllBreakDownColumnData(schoolId) {
    return instance.get(`api/event/getAllColumnBreakdown/${schoolId}`, {
      headers: authHeader(),
    });
  }

  updateBreakDownValuesToTable(arr) {
    return instance.post("api/event/updateMediaBreakdownList", arr, {
      headers: authHeader(),
    });
  }

  addNewColumnSet(schoolId, columnName) {
    return instance.post(
      "api/breakdown/columName",
      {
        schoolId,
        columnName,
      },
      { headers: authHeader() }
    );
  }

  addBreakdownsToNewColumnSet(schoolId, columnName) {
    return instance.post(
      "api/event/addNewColumnSetToBreakdown",
      {
        schoolId,
        columnName,
      },
      {
        headers: authHeader(),
      }
    );
  }

  updateDefaultColumnBreakdown(schoolId, columnNameId) {
    return instance.put(
      `api/event/updateDefaultColumnBreakdown/${schoolId}`,
      null,
      {
        params: {
          columnNameId: columnNameId,
        },
        headers: authHeader(),
      }
    );
  }

  deleteColumnSet(id) {
    return instance.delete(`api/breakdown/columName/${id}`, {
      headers: authHeader(),
    });
  }

  renameColumnSet(id, schoolId, columnName) {
    return instance.put(
      `api/breakdown/columName`,
      {
        id,
        columnName,
        schoolId,
      },
      { headers: authHeader() }
    );
  }

  getAllBreakdownsByColumnSetName(schoolId, id) {
    return instance.get(
      `api/event/getAllColumnBreakdownByColumn/${schoolId}?columnNameId=${id}`,
      {
        headers: authHeader(),
      }
    );
  }

  requestChangeBreakdownValue(
    schoolId,
    breakdownName,
    possibleValues,
    value,
    id
  ) {
    return instance.post(
      `api/event/requestChangeBreakdownValue`,
      {
        schoolId,
        breakdownName,
        possibleValues,
        value,
        id,
      },
      { headers: authHeader() }
    );
  }

  async initiateUpload(requestBody) {
    return axios.post(NODE_BASE_URL + "/file/initiateUpload", requestBody, {
      headers: authHeader(),
    });
  }

  async uploadChunk(formData) {
    return axios.post(NODE_BASE_URL + "/file/uploadChunk", formData, {
      headers: authHeader(),
    });
  }

  async completeUpload(requestBody, uploadId) {
    return axios.post(
      NODE_BASE_URL + "/file/completeUpload",
      {
        ...requestBody,
        uploadId,
      },
      { headers: authHeader() }
    );
  }

  uploadS3File(output) {
    return instance.post(`api/file/uploadS3File`, output, {
      headers: authHeader(),
    });
  }

  uploadLiveStreamingDetails(data) {
    return instance.post("/api/file/uploadLiveStreamingDetails", data, {
      headers: authHeader(),
    });
  }

  updateMatchScore(keyArray, scoreHomeSchool, scoreOpponentSchool) {
    return instance.post(
      "/api/channel/updateScore",
      {
        keyArray,
        scoreHomeSchool,
        scoreOpponentSchool,
      },
      { headers: authHeader() }
    );
  }
}
export default new UserService();
